<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="2">
        <div class="text-subtitle-2" v-text="$t('Admin.sort')"></div>
        <v-select :items="sortItems" v-model="sortFilter" solo></v-select>
      </v-col>
      <v-col cols="12" sm="2">
        <div class="text-subtitle-2" v-text="$t('Admin.type')"></div>
        <v-select
          clearable
          :items="['Name','Id']"
          :placeholder="$t('Admin.enterType')"
          v-model="filterAttribute"
          solo
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <div class="text-subtitle-2" v-text="$t('Admin.filter')"></div>
        <v-text-field :placeholder="$t('Admin.enterFilter')" solo v-model="filter"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <v-btn class="mb-5" tile outlined color="primary" @click="$emit('create')">
          <v-icon left>mdi-plus-circle</v-icon>
          {{$t('DataHome.create')}}
        </v-btn>
      </v-col>
    </v-row>
    <template v-if="loading">
      <v-row justify="center">
        <v-col>
          <div class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col v-for="dev in devicesArray" :key="dev.id" cols="12" sm="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              :id="dev.id"
              style="cursor: pointer;"
              :elevation="hover ? 10 : 2"
              class="mx-auto"
              max-width="344"
              @click="sendChoosenDevice($event)"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="subtitle-2 mb-4 text-uppercase">{{dev.id}}</div>
                  <v-list-item-title class="headline mb-1">{{dev.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{$t('Admin.networkId')}}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{dev.networkId}}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{$t('Admin.deviceTypeId')}}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{dev.deviceTypeId}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </template>
    <v-alert type="warning" v-if="!loading && noDevice">{{$t('Admin.nodevices')}}</v-alert>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    source: String
  },
  data: () => ({
    devices: [],
    noDevice: true,
    filterAttribute: undefined,
    filter: "",
    sortFilter: "",
    sortItems: [],
    loading: true
  }),
  computed: {
    devicesArray: function() {
      let array = this.devices;
      if (this.filterAttribute != undefined) {
        array = [];
        this.devices.forEach(device => {
          if (
            device[
              this.filterAttribute.charAt(0).toLowerCase() +
                this.filterAttribute.slice(1)
            ]
              .toLowerCase()
              .startsWith(this.filter.toLowerCase())
          ) {
            array.push(device);
          }
        });
      }
      function compareWithParam(param) {
        return function compare(d1, d2) {
          let a = d1.name;
          let b = d2.name;
          if (param == "Id") {
            a = d1.id;
            b = d2.id;
          }
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        };
      }

      if (array != undefined) {
        switch (this.sortFilter) {
          default:
            return array.sort(compareWithParam(this.filterAttribute));

          case this.$t("Admin.ascending"):
            return array.sort(compareWithParam(this.filterAttribute));

          case this.$t("Admin.descending"):
            return array.sort(compareWithParam(this.filterAttribute)).reverse();
        }
      } else {
        return array;
      }
    }
  },

  methods: {
    sendChoosenDevice: function(event) {
      let index = this.devices.findIndex(e => {
        return e.id == event.currentTarget.id;
      });
      this.$emit("choosendevice", this.devices[index]);
    }
  },
  beforeMount: function() {
    this.sortItems = [this.$t("Admin.ascending"), this.$t("Admin.descending")];
    this.sortFilter = this.sortItems[0];
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/device", {
        headers: { Authorization: tokenStore.getToken() }
      })
      .then(res => {
        if (res.data.devices.length == 0) {
          this.noDevice = true;
          this.loading = false;
        } else {
          this.noDevice = false;
          res.data.devices.forEach(dev => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/deviceType/" +
                  dev.deviceTypeId,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                dev.deviceType = res.data.deviceType.name;
                this.devices.push(dev);
              })
              .catch(() => {
                this.alertMsg = this.$t("DataHome.api-error");
                this.alertType = "error";
                this.alertShow = true;
              });
          });
          this.loading = false;
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>
